import React, { useState } from 'react';
import { utcToZonedTime } from 'date-fns-tz';
import isSameDay from 'date-fns/isSameDay';
import Calendar from './Calendar';
import { head } from 'lodash';
import { useTheme } from 'styled-components';

interface IDateOption {
  label: string;
  value: string;
}

const CalendarWrapper = (props) => {
  const { onDateSelected, isDateEnabled } = props;
  const initialDate = props.selectedDate || new Date();
  const [state, setState] = useState({
    month: initialDate.getMonth() + 1,
    year: initialDate.getFullYear(),
    selected: null,
    selectedDate: initialDate,
  });
  const theme = useTheme();

  const onChangeDate = (option: IDateOption) => {
    const curr = utcToZonedTime(new Date(option.value).toISOString(), 'Europe/Moscow');
    const month = curr.getMonth() + 1;
    const year = curr.getFullYear();

    setState((prevState) => ({
      ...prevState,
      month,
      year,
    }));
  };

  const handleDateSelect = (date) => {
    const firstDate = Array.isArray(date) ? head(date) : date;

    if (theme.isMobile) {
      return setState((prevState) => ({
        ...prevState,
        selected: firstDate,
        selectedDate: firstDate.date,
      }));
    }

    if (Array.isArray(date) && date.length > 1) {
      return setState((prevState) => ({
        ...prevState,
        selected: firstDate,
        selectedDate: firstDate.date,
      }));
    }

    window.Widget.calendarController.hide();
    if (onDateSelected && firstDate) onDateSelected(firstDate);
  };

  const onSubmitDate = (date) => {
    const firstDate = Array.isArray(date) ? head(date) : date;

    window.Widget.calendarController.hide();
    if (onDateSelected && firstDate) onDateSelected(state.selected);
  };

  const isDateSelected = (data) => {
    return isSameDay(state.selectedDate, data.date);
  };

  return (
    <Calendar
      // @ts-ignore
      rerender={{
        // hovered: state.hovered,
        date: props.selectedDate,
      }}
      selectedDate={state.selectedDate}
      startDate={props.startDate}
      endDate={props.endDate}
      month={state.month}
      year={state.year}
      isDateSelected={isDateSelected}
      isDateEnabled={isDateEnabled}
      onDateSelected={handleDateSelect}
      onChangeDate={onChangeDate}
      onSubmitDate={onSubmitDate}
      locale={props.locale}
      disabled={props.disabled}
      daysTimes={props.daysTimes}
    />
  );
};

export default CalendarWrapper;
